import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';
import Calendar from '../../shared/calendar/main';

import Switch from '../components/switch';
import Table from '../components/table/unacceptable-stat/main';

import { selectors as rootSelectors } from '../../root';
import Filters from '../../shared/filters/main';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content conversions">
			<div className="container__content-title">
				<div className="container__content-title-position border-hide">
					<h2 className="title">{props.intl('Statistics')}</h2>
				</div>
				<Switch {...props}/>
			</div>
			<div className="container__content-body">
				<div className="conversions__filter-position clearfix">
					<Filters
						{...props}
						{...props.filters}
					/>
				</div>
				<div className="ui-control-bar height-100">
					<div className="ui-control-bar__item-position display-flex-column">
						<div className="display-flex justify-content-flex-end">
							<div className="ui-control-bar__item modify-item---calendar">
								<div className="ui-control-bar__item-position">
									<Calendar
										{...props.calendar}
										onInit={props.calendarInit}
										onToggle={props.calendarToggle}
										onChange={props.calendarChange}
										onApply={props.calendarApply}
										intl={props.intl}/>
								</div>
							</div>
							<div className="ui-control-bar__item margin-0-10">
								<div className="ui-control-bar__item-position">
									<button className="ui-btn ui-btn-primary apply" onClick={props.exportCsv}>
										{props.intl('Export')}
									</button>
								</div>
							</div>
							<button className="ui-btn ui-btn-primary apply margin-0-10" onClick={props.apply}>
								{props.intl('Apply')}
							</button>
						</div>
					</div>
				</div>

				<div className="conversions__table-position">
					<Table
						{...props}
						isIndexing
					/>
				</div>
			</div>
		</div>
	</Animate>
), 'autotrash_view');

export default connect(
	state => ({
		data: selectors.getData(state),
		table: selectors.getTable(state),
		calendar: selectors.getCalendar(state),
		filters: selectors.getFilters(state),
		intl: selectors.getIntl(state),
		progressBar: selectors.getProgressBar(state),
		checkedBan: selectors.getCheckedBan(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		searchInitialValues: selectors.getSearchInitialValues(state),
		filterContextForSwitchControl: selectors.getFilterContext(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/statistics/unacceptable-conversions-stat/main.js